export const LOADING_ACTIVITIES = "activity-feed/LOADING_ACTIVITIES";
export const LOADED_ACTIVITIES = "activity-feed/LOADED_ACTIVITIES";
export const WAIT_ACTIVITIES = "activity-feed/WAIT_ACTIVITIES";
export const LOADING_THREADS = "activity-feed/LOADING_THREADS";
export const LOADED_THREADS = "activity-feed/LOADED_THREADS";
export const WAIT_THREADS = "activity-feed/WAIT_THREADS";
